import { render } from "./InvestasiDataSektor.vue?vue&type=template&id=8aa082ea"
import script from "./InvestasiDataSektor.vue?vue&type=script&lang=js"
export * from "./InvestasiDataSektor.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__